import { render } from "./honda.vue?vue&type=template&id=b62875ec"
import script from "./honda.vue?vue&type=script&lang=js"
export * from "./honda.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__